import { useMemo } from "react";
import showdown from "showdown";
import DOMPurify from "dompurify";

/**
 * (From the Cordino App)
 * Displays Markdown content as HTML. Takes a `content` prop with a markdown string
 * and all remaining props are passed on to the parent <article> element.
 *
 * This component doesn't offer any styling of its own, but you can pass a `className`
 * to define it yourself for the particular use case.
 */
export function Markdown({ content, style, ...props }) {
  const rendered = useMemo(() => {
    const converter = new showdown.Converter();
    const html = content
      ? converter.makeHtml(content.replace(/linebreaktag/gi, "<p><br/></p>"))
      : "";
    return DOMPurify.sanitize(html, {
      USE_PROFILES: { html: true },
      FORBID_TAGS: ["style"],
      FORBID_ATTR: ["style"],
    });
  }, [content]);
  return (
    <article
      {...props}
      style={style}
      dangerouslySetInnerHTML={{ __html: rendered }}
    />
  );
}
